var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M256 512A254 254 0 010 256 254 254 0 01256 0a254 254 0 01256 256 254 254 0 01-256 256z","fill":"rgba(var(--bg-primary), var(--bg-alpha))","key":0}),React.createElement("path",{"d":"M394 290L256 152 118 290l28 28 110-110 110 110z","fill":"rgb(var(--text-tertiary))","key":1})]);
}

Chevron.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Chevron;

Chevron.default = Chevron;
